import { render, staticRenderFns } from "./sendBoardMessage.vue?vue&type=template&id=5d7a8d0c&scoped=true&"
import script from "./sendBoardMessage.vue?vue&type=script&lang=js&"
export * from "./sendBoardMessage.vue?vue&type=script&lang=js&"
import style0 from "./sendBoardMessage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sendBoardMessage.vue?vue&type=style&index=1&id=5d7a8d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a8d0c",
  null
  
)

export default component.exports